export default "<router-outlet></router-outlet>\r\n<ngx-spinner></ngx-spinner>"